export class AccountUserInfo{        
    firstName:string;    
    lastName:string;
    company: string;
    countryName: string;        
}



// WEBPACK FOOTER //
// ./src/app/modules/account/entity/account-user-info.ts